var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_821_613",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_821_613",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAsQAAALEBxi1JjQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAKiSURBVEiJnZZNSFRhFIafc+/MokiM/gwVNZSyIqKVaRa1KVJIU8aCgvzBrQZCEERlUpsWUbYIJPxrIfhTmq6CFpalVCQuNBeZ6WTWptKN4dx7WuiYjt65M767e8573vN+H+f7viuEQbavKclWKw8hF0hRSAQQ8APjgnabJp29LaWTThqyVjDT15ggWNdBygAznAnAFqHdMrjS31Iy7togs6g+X1SaQTe5CIdiVpCLfa3FXcuDxkrn9ZWitK9DHCBG0adZRQ0Vy4NLK1hwTnto0xVuRDh8KIHkhFhMw+CL/zd9H1Ztvy3I2eBKBCCjoC7RNL0j4Zx7vSb3r53k4N64pVj/4Deq7rxYiz4rpp3e11I2ZQCYHu8tt20pPJW+Qhxgft5yoseobVYDSLavKcnGGsNlWm5XneB4RjIAV+++5OPwNHN/A8wHbKcSy7ICKR5b7HzUdRTZunnDYpVN77sJNzqAaXi8eYaono6EHYRGwRXVHI8iaeHKblYeY3/adrZt2bhoy6C1thCAodGf1Dx8Fa5HqgfYGY6RFB9LfFzMf1fC0vfniV9ua0hwnPkg5uYCjjn/9KxLtdqS5asfBXa7NXpUk8OBPTuwVTl6rtGNHsQnQ2AsUvaCqajYYwZoT1QlUUG7DdOkE3A8kuuHBCzLem70tpROKjRE7Ekj2yMRfTzQUe5fnCLjBuA2EtFgxgh4qmHx/vEPP5tN2lcwiOh5HK5rBb5O/eH90HcGR36EE7cNoeh126UPEPKiZRU1VKB6z6lJBLBRLr9pK6kNBlY9mUd8DWcUfQLEhOZcMKOqF962lXYvD65y2tda3GWiqag+AHE+xstdQ7NpedJDxcHhryKIjIK6RMPjzUPtXEF2gSQuZNQPjKH0WHaga6Cj3O+k8Q+MBeoQ1rfnXwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d88136d318918743a9afd8681cf89583.svg";
export { ForwardRef as ReactComponent };